import React, { useEffect } from 'react';
import Navbar from './Navbar';
import Hero from './Hero';
import Features from './Features';
import ScriptsSupport from './ScriptsSupport';
import ProfessionalTeams from './ProfessionalTeams';
import MobileSection from './MobileSection';
import ShiftLeft from './ShiftLeft';
import FutureWorkflow from './FutureWorkflow';
import WhyImago from './WhyImago';
import CTA from './CTA';
import Footer from './Footer';
import InstallBanner from './InstallBanner';
import Reveal from './Reveal';

const LandingPage = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="w-full min-h-screen bg-[#0a0a0a] overflow-y-auto selection:bg-cyan-500/20 selection:text-cyan-300">
            {/* Subtle grid background */}
            <div className="fixed inset-0 pointer-events-none z-0">
                <div className="absolute inset-0 bg-[linear-gradient(rgba(0,240,255,0.03)_1px,transparent_1px),linear-gradient(90deg,rgba(0,240,255,0.03)_1px,transparent_1px)] bg-[size:60px_60px]" />
                <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[600px] bg-cyan-500/5 blur-[150px] rounded-full" />
            </div>
            <div className="relative z-10">
                <Navbar />
                <main className="pt-20">
                    <Reveal><Hero /></Reveal>
                    <Features />
                    <Reveal><ScriptsSupport /></Reveal>
                    <ProfessionalTeams />
                    <MobileSection />
                    <FutureWorkflow />
                    <ShiftLeft />
                    <WhyImago />
                    <Reveal><CTA /></Reveal>
                </main>
                <Footer />
                <InstallBanner />
            </div>
        </div>
    );
};

export default LandingPage;
